const Butter = require('buttercms')
export const butter = Butter('3c071fe00f422a4fe38b84e554384faf16a2f3e6')
